import React from 'react'

import { Box, makeStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useBrandStyles from './CustomerSidebarBrandStyles'

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    paddingTop: theme.spacing(3),
    color: theme.palette.secondary.contrastText,
    overflow: 'visible',
    width: 'inherit',
    height: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
}))

const CustomerSidebarSkeleton: React.FC = () => {
  const brandClasses = useBrandStyles()
  const classes = useStyles()

  return (
    <Box className={`${brandClasses.skeleton} ${classes.mainWrapper}`} p={12}>
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="rect" height={90} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
      <Skeleton animation="wave" variant="text" height={30} />
      <br />
    </Box>
  )
}

export default CustomerSidebarSkeleton
